import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class HostnameQueryCriteriaClass extends BaseCriteriaModel {
  // from header
  hostname_type?: Optional<string> = Optional.empty();
  hostname_value?: Optional<string> = Optional.empty();
  hostname_url?: Optional<string> = Optional.empty();

  // from extension
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();
  value_datetime?: Optional<string> = Optional.empty();
}

export class HostnameCriteriaModelQuery {
  query = '';

  constructor(HostnameCriteriaModel: HostnameQueryCriteriaClass) {

    if (!HostnameCriteriaModel) {
      return;
    }

    this.query += HostnameCriteriaModel.hostname_type.filter(x => x !== '').map(x => '&hostname_type=' + x).orElse('');
    this.query += HostnameCriteriaModel.hostname_value.filter(x => x !== '').map(x => '&hostname_value=' + x).orElse('');
    this.query += HostnameCriteriaModel.hostname_url.filter(x => x !== '').map(x => '&hostname_url=' + x).orElse('');

    this.query += HostnameCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += HostnameCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += HostnameCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += HostnameCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += HostnameCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');
    this.query += HostnameCriteriaModel.value_datetime.filter(x => x !== '').map(x => '&value_datetime=' + x).orElse('');

    this.query += '&status=' + HostnameCriteriaModel.status;
    this.query += '&orderBy=' + HostnameCriteriaModel.orderBy;
    this.query += '&order=' + HostnameCriteriaModel.order;
    this.query += '&offset=' + HostnameCriteriaModel.offset + '&limit=' + HostnameCriteriaModel.limit;
  }
}
